import { useQuery } from '@tanstack/react-query'
import { Activity } from 'lucide-react'
import { fetchServiceHealth } from '../lib/api'
import { services } from '../lib/registry'
import { HealthPill } from '../components/HealthPill'

// Health of every backend the team operates (notification_center +
// pii_access_control) — the old per-service health tab, folded into one page.
export default function SystemHealthPage() {
  return (
    <>
      <div className="page-head">
        <h2><Activity size={20} /> System Health</h2>
      </div>
      <p className="page-desc muted">
        สถานะ readiness ของ backend ทุกตัวที่ทีมดูแล — BFF เรียก <code>/healthz</code> ของแต่ละ service
        ผ่านเครือข่ายภายใน รีเฟรชอัตโนมัติทุก 10 วินาที
      </p>
      <div className="two-col">
        {services.map((s) => <ServiceHealthCard key={s.slug} slug={s.slug} name={s.name} />)}
      </div>
    </>
  )
}

function ServiceHealthCard({ slug, name }: { slug: string; name: string }) {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['health', slug],
    queryFn: () => fetchServiceHealth(slug),
    refetchInterval: 10_000,
  })

  const upstream = data?.body && typeof data.body === 'object' && 'status' in (data.body as object)
    ? (data.body as { status: string; service?: string; version?: string; time?: string; checks?: unknown })
    : null

  return (
    <div className="panel">
      <h3 style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        {name}
        {isLoading ? <span className="muted small">กำลังตรวจ…</span>
          : <HealthPill status={data?.httpStatus === 200 ? 'ok' : 'down'} />}
      </h3>
      {isError && <div className="error">{(error as Error).message}</div>}
      <dl className="kv">
        <dt>HTTP</dt><dd>{data?.httpStatus ?? '—'}</dd>
        <dt>Service</dt><dd>{upstream?.service ?? slug}</dd>
        <dt>Version</dt><dd>{upstream?.version ?? '—'}</dd>
        <dt>ตรวจเมื่อ</dt><dd>{data?.fetchedAt ? new Date(data.fetchedAt).toLocaleTimeString('th-TH') : '—'}</dd>
      </dl>
      <pre className="json small-json">{JSON.stringify(data?.body ?? {}, null, 2)}</pre>
    </div>
  )
}
